import { createAction } from "@ngrx/store";
import { createGetSuccessAction } from "@obg/ngrx-utils";
import { AppError } from "@obg/ngx.core";

import { Icon } from "./icon.model";

export const ACTION_PREFIX = "[Icon]";
/**
 * @deprecated [fabric-deprecated] - Use "document.obgEventBus.retrieve(ContentValue.getIcons_v2)" instead
 */
export namespace IconAction {
	/**
	 * @deprecated [fabric-deprecated] - Use "document.obgEventBus.retrieve(ContentValue.getIcons_v2)" instead
	 */
	export const getAll = createAction(`${ACTION_PREFIX} Get All`);

	export const getAllSuccess = createGetSuccessAction(
		createAction(`${ACTION_PREFIX} Get All Success`, (icons: Record<string, Icon[]>) => ({ payload: icons }))
	);

	export const getAllFail = createAction(`${ACTION_PREFIX} Get Fail`, (error: AppError) => ({ payload: error }));
}
